(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dog-pendant-studio"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  const ALIASES = Object.freeze({ frenchie: 'french bulldog', yorkie: 'yorkshire terrier', dobie: 'doberman pinscher', doberman: 'doberman pinscher', corgi: 'pembroke welsh corgi', gsd: 'german shepherd', 'g s d': 'german shepherd', aussie: 'australian shepherd', lab: 'labrador retriever' });
  const normalize = value => String(value || '').normalize('NFKD').replace(/\p{M}/gu, '').toLowerCase().replace(/[\p{P}\p{S}_]+/gu, ' ').replace(/\s+/g, ' ').trim();
  const matches = (breed, query) => { const term = normalize(query); const name = normalize(breed); return !term || name.includes(term) || ALIASES[term] === name; };
  const resolveVariant = (product, selection) => product.variants.find(variant => product.options.every(option => variant.selections[option.name] === selection[option.name]));
  const resolveStudioRoute = (products, url) => {
    const explicitBreed = url.searchParams.has('breed');
    const product = explicitBreed ? products.find(item => item.handle === url.searchParams.get('breed')) : products[0];
    if (!product) return { error: 'unknownBreed' };
    const pinned = url.searchParams.has('variant');
    const id = url.searchParams.get('variant');
    const variant = pinned ? (/^[1-9]\d*$/.test(id || '') && product.variants.find(item => String(item.id) === id)) : product.variants.find(item => item.available) || product.variants[0];
    if (!variant) return { error: 'invalidVariant' };
    return { product, variant, explicitBreed };
  };
  const validDisplayScope = manifest => {
    const expected = manifest.collection?.expectedProducts;
    const scope = manifest.collection?.frontDisplayScope;
    return manifest.schema_version === 3 && Array.isArray(expected) && expected.length > 0 &&
      new Set(expected.map(item => String(item.id))).size === expected.length && new Set(expected.map(item => item.handle)).size === expected.length &&
      typeof scope?.approvalEvidence === 'string' && scope.approvalEvidence.length > 0 && Array.isArray(scope.productIds) && scope.productIds.length > 0 &&
      new Set(scope.productIds).size === scope.productIds.length && scope.productIds.every(id => expected.some(item => String(item.id) === String(id)));
  };
  const validFinish = preset => preset && Array.isArray(preset.baseColorFactor) && preset.baseColorFactor.length === 4 && preset.baseColorFactor.every(value => Number.isFinite(value) && value >= 0 && value <= 1) && preset.baseColorFactor[3] === 1 &&
    Number.isFinite(preset.metallicFactor) && preset.metallicFactor >= 0 && preset.metallicFactor <= 1 && Number.isFinite(preset.roughnessFactor) && preset.roughnessFactor >= 0 && preset.roughnessFactor <= 1;
  const canRotateModel = (manifest, entry) => {
    if (!validDisplayScope(manifest) || !entry) return false;
    const scope = manifest.collection.customerRotationScope;
    const bound = scope?.products?.find(item => item.handle === entry.handle);
    const authorized = scope?.customerRotationAuthorized === true && scope.purpose === 'ILLUSTRATIVE_CUSTOMER_VIEW' &&
      typeof scope.authorizationEvidence === 'string' && scope.authorizationEvidence.length > 0 && /^[a-f0-9]{64}$/.test(scope.authorizationEvidenceSha256 || '') &&
      entry.customerRotationAuthorized === true && bound?.derivativeSha256 === entry.provenance?.derivativeSha256 && /^[a-f0-9]{64}$/.test(bound?.derivativeSha256 || '') &&
      manifest.collection.expectedProducts.some(item => String(item.id) === String(bound?.id) && item.handle === entry.handle);
    return Boolean(authorized || (entry.owner360Approval === true && entry.sideViewsApproved === true && entry.rearViewApproved === true && typeof entry.view360Evidence === 'string' && entry.view360Evidence.length > 0));
  };
  const allowedModel = (manifest, product, variant) => {
    if (!validDisplayScope(manifest) || !manifest.collection.frontDisplayScope.productIds.some(id => String(id) === String(product.id))) return null;
    const expected = manifest.collection.expectedProducts.find(item => String(item.id) === String(product.id));
    const entry = manifest.products?.[String(product.id)];
    if (!entry || expected?.handle !== product.handle || entry.handle !== product.handle || entry.status !== 'WEB_READY' || entry.frontAppearanceApproved !== true || entry.stagingDisplayAuthorized !== true || entry.approvalScope !== 'LIMITED_FRONT_APPEARANCE' ||
        entry.frontView?.coordinateContract !== 'Y_UP_FRONT_POSITIVE_Z_CENTERED_V1' || entry.frontView.cameraOrbit !== '0deg 90deg auto' || entry.frontView.framingApproved !== true || typeof entry.materialName !== 'string' || !entry.materialName) return null;
    const finish = variant.selections[product.options.find(option => normalize(option.name) === 'gold color')?.name];
    const preset = entry.finishes?.[finish];
    if (!validFinish(preset)) return null;
    const src = entry.src;
    try {
      const url = new URL(src);
      const themeHost = typeof window !== 'undefined' && url.origin === window.location?.origin && url.pathname.startsWith('/cdn/shop/');
      if (url.protocol !== 'https:' || !(url.hostname === 'cdn.shopify.com' || themeHost) || !url.pathname.endsWith('.glb') || url.hash || [...url.searchParams].some(([key,value]) => key !== 'v' || !/^\d+$/.test(value))) return null;
    } catch (_) { return null; }
    return { ...entry, src, preset, canRotate: canRotateModel(manifest, entry) };
  };
  const applyModelFinish = (viewer, model) => {
    if (!validFinish(model.preset)) throw new Error('Missing approved finish');
    const material = viewer.model?.getMaterialByName(model.materialName);
    const pbr = material?.pbrMetallicRoughness;
    if (!pbr?.setBaseColorFactor || !pbr.setMetallicFactor || !pbr.setRoughnessFactor) throw new Error('Required material API unavailable');
    pbr.setBaseColorFactor(model.preset.baseColorFactor);
    pbr.setMetallicFactor(model.preset.metallicFactor);
    pbr.setRoughnessFactor(model.preset.roughnessFactor);
  };
  class SelectionRevealGuard {
    constructor({ ready, misaligned, reveal, schedule = callback => setTimeout(callback, 100), cancel = timer => clearTimeout(timer), now = () => Date.now() }) {
      Object.assign(this, { ready, misaligned, reveal, schedule, cancel, now });
      this.started = now();
      this.readyAt = null;
      this.tick();
    }
    tick() {
      if (this.stopped) return;
      const now = this.now();
      const expired = now - this.started >= 8000;
      if (this.ready() || expired) {
        if (this.readyAt === null) this.readyAt = now;
        if (this.misaligned()) this.reveal();
        if (expired || now - this.readyAt >= 2000) return this.stop();
      }
      this.timer = this.schedule(() => this.tick());
    }
    stop() { this.stopped = true; this.cancel(this.timer); }
  }
  let runtimePromise;
  const loadViewerRuntime = runtimeUrl => {
    if (customElements.get('model-viewer')) return Promise.resolve();
    if (!runtimePromise) runtimePromise = new Promise((resolve, reject) => {
      let url;
      try {
        url = new URL(runtimeUrl, window.location.href);
        if (url.protocol !== 'https:' || !(url.hostname === 'cdn.shopify.com' || url.origin === window.location.origin) || !url.pathname.endsWith('/dog-studio-model-viewer-4.3.1.min.js')) throw new Error('Invalid runtime');
      } catch (_) { reject(new Error('Viewer unavailable')); return; }
      const script = document.createElement('script');
      script.type = 'module';
      script.src = url.href;
      const timeout = setTimeout(() => { script.remove(); reject(new Error('Viewer load timeout')); }, 15000);
      const done = error => { clearTimeout(timeout); if (error || !customElements.get('model-viewer')) { script.remove(); reject(new Error('Viewer unavailable')); } else resolve(); };
      script.addEventListener('load', () => done(false), { once: true });
      script.addEventListener('error', () => done(true), { once: true });
      document.head.append(script);
    }).catch(error => { runtimePromise = null; throw error; });
    return runtimePromise;
  };
  if (typeof module !== 'undefined' && module.exports) module.exports = { normalize, matches, resolveVariant, resolveStudioRoute, allowedModel, validDisplayScope, canRotateModel, applyModelFinish, SelectionRevealGuard };
  if (typeof window === 'undefined' || !window.customElements || customElements.get('dog-pendant-studio')) return;
  class DogPendantStudio extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      queueMicrotask(() => { if (this.isConnected && !this.events) this.initialize(); });
    }
    initialize() {
      const payload = this.querySelector('[data-studio-data]');
      if (!payload) return;
      try { this.data = JSON.parse(payload.textContent); this.manifest = JSON.parse(this.querySelector('[data-model-manifest]').textContent); } catch (_) { return; }
      this.events = new AbortController();
      this.signal = this.events.signal;
      this.cards = [...this.querySelectorAll('[data-breed-card]')];
      this.rows = [...this.querySelectorAll('[data-breed-list]')];
      this.search = this.querySelector('[data-search]');
      this.panel = this.querySelector('[data-selected-panel]');
      this.form = this.querySelector('[data-studio-form]');
      this.querySelector('[data-search-ui]').hidden = false;
      this.querySelectorAll('[data-enhanced]').forEach(node => { node.hidden = false; });
      this.search.addEventListener('input', () => this.filter(), { signal: this.signal });
      this.search.addEventListener('keydown', event => { if (event.key === 'Escape') this.clearSearch(); }, { signal: this.signal });
      this.querySelector('[data-clear]').addEventListener('click', () => this.clearSearch(), { signal: this.signal });
      const spaceHero=this.querySelector('dog-space-hero');
      const selectSpace=handle=>{const link=[...(spaceHero?.querySelectorAll('[data-space-select]')||[])].find(a=>a.dataset.spaceSelect===handle);const product=this.data.products.find(p=>p.handle===handle);if(link&&product&&String(link.dataset.productId)===String(product.id))this.select(handle,null,true);};
      this.addEventListener('dog-space:select',event=>{if(event.target===spaceHero)selectSpace(event.detail?.handle);},{signal:this.signal});
      if(spaceHero){this.spaceVisibility=new IntersectionObserver(entries=>{if(entries[0].isIntersecting){this.spaceVisibility.disconnect();const src=new URL(spaceHero.dataset.spaceModule,location.href);if(src.protocol==='https:'&&(src.origin===location.origin||src.hostname==='cdn.shopify.com')&&/\/dog-space-hero-[a-f0-9]{12}\.js$/.test(src.pathname)){const script=document.createElement('script');script.type='module';script.src=src.href;document.head.append(script);}}});this.spaceVisibility.observe(spaceHero);}
      this.addEventListener('click', event => {
        const spaceLink=event.target.closest('[data-space-select]');
        if(spaceLink&&spaceHero?.contains(spaceLink)&&!event.ctrlKey&&!event.metaKey&&!event.shiftKey&&!event.altKey&&event.button===0){event.preventDefault();selectSpace(spaceLink.dataset.spaceSelect);return;}
        const pick = event.target.closest('[data-select-breed]');
        if (pick && this.contains(pick)) { event.preventDefault(); this.select(pick.dataset.selectBreed, null, true); }
        const arrow = event.target.closest('[data-scroll]');
        if (arrow) { const row = this.rows[Number(arrow.dataset.row)]; row.scrollBy({ left: Number(arrow.dataset.scroll) * row.clientWidth * .8, behavior: this.reduced.matches ? 'auto' : 'smooth' }); }
      }, { signal: this.signal });
      this.form.addEventListener('change', () => this.changeVariant(), { signal: this.signal });
      this.form.addEventListener('submit', event => {
        const variant = this.current && resolveVariant(this.current, this.selection());
        if (!variant || !variant.available || String(variant.id) !== this.form.elements.id.value) { event.preventDefault(); this.status(this.data.strings.unavailable); return; }
        this.dispatchEvent(new CustomEvent('dog-studio:cart-intent', { bubbles: true, detail: { productId: this.current.id, variantId: variant.id } }));
      }, { signal: this.signal });
      this.querySelector('[data-load-model]').addEventListener('click', () => this.loadModel(), { signal: this.signal });
      this.querySelector('[data-close-model]').addEventListener('click', () => this.closeModel(), { signal: this.signal });
      this.querySelector('[data-reset-front]')?.addEventListener('click', () => this.resetFront(), { signal: this.signal });
      this.querySelector('[data-model-motion]').addEventListener('click', () => this.setModelMotion(!this.modelMotion), { signal: this.signal });
      this.querySelectorAll('[data-view-mode]').forEach(button => button.addEventListener('click', () => this.setViewMode(button.dataset.viewMode), { signal: this.signal }));
      this.querySelector('[data-pause]')?.addEventListener('click', () => this.toggleMotion(), { signal: this.signal });
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reduced.addEventListener('change', () => { this.pauseMotion(); this.setModelMotion(false); this.updateModelControls(); }, { signal: this.signal });
      document.addEventListener('visibilitychange', () => { if (document.hidden) { this.pauseMotion(); this.setModelMotion(false); } }, { signal: this.signal });
      this.modelInViewport = false;
      this.modelVisibility = new IntersectionObserver(entries => this.setModelVisibility(entries[0].isIntersecting));
      this.modelVisibility.observe(this.querySelector('[data-viewer]'));
      const heroVideo = this.querySelector('[data-hero-video]');
      if (heroVideo) {
        this.heroVisibility = new IntersectionObserver(entries => { if (!entries[0].isIntersecting) this.pauseMotion(); });
        this.heroVisibility.observe(heroVideo);
      }
      this.rows.forEach(row => row.addEventListener('scroll', () => this.updateArrows(), { signal: this.signal, passive: true }));
      this.resize = new ResizeObserver(() => this.updateArrows());
      this.rows.forEach(row => this.resize.observe(row));
      this.selectFromURL();
      window.addEventListener('popstate', () => this.selectFromURL(), { signal: this.signal });
      this.pauseMotion();
      this.filter();
    }
    disconnectedCallback() { this.imageGeneration = (this.imageGeneration || 0) + 1; this.events?.abort(); this.resize?.disconnect(); this.modelVisibility?.disconnect(); this.heroVisibility?.disconnect(); this.spaceVisibility?.disconnect(); this.pauseMotion(); this.disposeModel(); this.events = null; }
    selection() { return Object.fromEntries([...this.form.querySelectorAll('[data-option-name]')].map(select => [select.dataset.optionName, select.value])); }
    clearSearch() { this.search.value = ''; this.filter(); this.search.focus(); }
    filter() {
      const visible = this.cards.filter(card => matches(card.dataset.breed, this.search.value));
      const split = Math.ceil(visible.length / 2);
      this.cards.forEach(card => { card.hidden = !visible.includes(card); });
      visible.forEach((card, index) => this.rows[index < split ? 0 : 1].append(card));
      this.rows.forEach(row => { row.parentElement.hidden = ![...row.children].some(child => !child.hidden); row.scrollLeft = 0; });
      this.querySelector('[data-count]').textContent = this.data.strings.results.replace('[count]', String(visible.length));
      this.querySelector('[data-empty]').hidden = visible.length !== 0;
      this.querySelector('[data-clear]').hidden = !this.search.value;
      this.updateArrows();
    }
    updateArrows() { this.rows.forEach((row, index) => { const max = row.scrollWidth - row.clientWidth; this.querySelector(`[data-row="${index}"][data-scroll="-1"]`).disabled = row.scrollLeft <= 2; this.querySelector(`[data-row="${index}"][data-scroll="1"]`).disabled = row.scrollLeft >= max - 2; }); }
    selectFromURL() {
      const url = new URL(location.href);
      const route = resolveStudioRoute(this.data.products, url);
      if (route.error) { this.clearSelection(route.error); return; }
      const { product, variant, explicitBreed } = route;
      const mode = url.searchParams.get('mode');
      const model = allowedModel(this.manifest, product, variant);
      this.modelPreferred = Boolean(explicitBreed && model && (mode === 'float' || (mode === '360' && model.canRotate)));
      this.preferredViewMode = this.modelPreferred ? mode : undefined;
      this.select(product.handle, variant.id, false);
      if (url.searchParams.has('mode') && !this.modelPreferred) this.syncViewURL(null);
      if (explicitBreed) {
        if (this.modelPreferred && this.activeModel) this.startInitialReveal();
        else this.revealSelection('instant');
      }
    }
    clearSelection(error) {
      this.disposeModel();
      this.imageGeneration = (this.imageGeneration || 0) + 1;
      this.imageReady = false;
      this.current = null;
      this.modelPreferred = false;
      this.preferredViewMode = undefined;
      this.panel.hidden = true;
      this.form.elements.id.value = '';
      this.form.elements.id.disabled = true;
      this.querySelector('[data-options]').replaceChildren();
      this.querySelector('[data-add]').disabled = true;
      this.querySelector('[data-checkout]').disabled = true;
      this.querySelector('[data-load-model]').hidden = true;
      this.querySelector('[data-image-loading]').hidden = true;
      for (const selector of ['[data-selected-name]', '[data-price]', '[data-selection-summary]']) this.querySelector(selector).textContent = '';
      const image = this.querySelector('[data-selected-image]');
      image.hidden = true;
      image.removeAttribute('src');
      image.alt = '';
      this.querySelector('[data-product-link]').removeAttribute('href');
      this.cards.forEach(card => { card.classList.remove('dps__card--selected'); card.querySelector('[data-select-breed]')?.setAttribute('aria-pressed', 'false'); });
      this.status('');
      const notice = this.querySelector('[data-route-error]');
      notice.textContent = notice.dataset[error];
      notice.hidden = false;
      notice.scrollIntoView({ block: 'center', behavior: 'instant' });
      notice.focus({ preventScroll: true });
    }
    revealSelection(behavior = this.reduced.matches ? 'auto' : 'smooth') {
      this.panel.scrollIntoView({ block: 'start', behavior });
      this.querySelector('[data-selected-name]').focus({ preventScroll: true });
      this.focusViewerWhenReady = true;
    }
    startInitialReveal() {
      this.stopInitialReveal();
      this.revealSelection('instant');
      const generation = this.modelGeneration;
      this.revealEvents = new AbortController();
      const cancel = () => { this.stopInitialReveal(); this.focusViewerWhenReady = false; };
      for (const type of ['wheel', 'touchstart', 'pointerdown', 'keydown']) document.addEventListener(type, cancel, { signal: this.revealEvents.signal, passive: true, capture: true });
      let fontsReady = !document.fonts;
      document.fonts?.ready.then(() => { fontsReady = true; }, () => { fontsReady = true; });
      this.initialReveal = new SelectionRevealGuard({
        ready: () => document.readyState === 'complete' && fontsReady && this.viewerLoaded,
        misaligned: () => {
          if (!this.isConnected || document.hidden || generation !== this.modelGeneration || this.panel.hidden) return false;
          const top = this.panel.getBoundingClientRect().top;
          return top < 60 || top > 140;
        },
        reveal: () => {
          this.panel.scrollIntoView({ block: 'start', behavior: 'instant' });
          if (this.viewerLoaded && this.viewMode === '360' && !document.hidden &&
              (document.activeElement === this.querySelector('[data-selected-name]') || document.activeElement === document.body)) this.focusModelControls();
        }
      });
    }
    stopInitialReveal() { this.initialReveal?.stop(); this.initialReveal = null; this.revealEvents?.abort(); this.revealEvents = null; }
    select(handle, variantId, updateURL) {
      const product = this.data.products.find(item => item.handle === handle);
      if (!product) { this.clearSelection('unknownBreed'); return; }
      const pinned = variantId !== null && variantId !== undefined;
      const variant = pinned ? product.variants.find(item => String(item.id) === String(variantId)) : product.variants.find(item => item.available) || product.variants[0];
      if (!variant) { this.clearSelection('invalidVariant'); return; }
      this.disposeModel();
      this.querySelector('[data-route-error]').hidden = true;
      this.current = product;
      this.panel.hidden = false;
      this.querySelector('[data-selected-name]').textContent = product.breed;
      if (updateURL) {
        this.modelPreferred = Boolean(allowedModel(this.manifest, product, variant)?.canRotate);
        this.preferredViewMode = this.modelPreferred ? this.preferredViewMode || '360' : undefined;
      }
      const options = this.querySelector('[data-options]'); options.replaceChildren();
      for (const option of product.options) {
        const label = document.createElement('label');
        const name = document.createElement('span'); name.textContent = option.name;
        const select = document.createElement('select'); select.dataset.optionName = option.name;
        select.name = `options[${option.name}]`;
        option.values.forEach(value => { const item = document.createElement('option'); item.value = value; item.textContent = value; select.append(item); });
        select.value = variant?.selections[option.name] || option.values[0];
        label.append(name, select); options.append(label);
      }
      this.cards.forEach(card => { const selected = card.dataset.handle === product.handle; card.classList.toggle('dps__card--selected', selected); const button = card.querySelector('[data-select-breed]'); button?.setAttribute('aria-pressed', String(selected)); });
      this.changeVariant(updateURL ? 'push' : false);
      this.status('');
      if (this.modelPreferred) this.loadModel();
      if (updateURL) this.revealSelection();
    }
    changeVariant(updateURL = true) {
      if (!this.current) return;
      const selection = this.selection();
      const variant = resolveVariant(this.current, selection);
      const nextModel = variant && allowedModel(this.manifest, this.current, variant);
      if (this.modelRequested && nextModel && this.activeModel?.src === nextModel.src) {
        try {
          if (this.viewerLoaded) applyModelFinish(this.viewer, nextModel);
          this.activeModel = nextModel;
          this.viewer?.setAttribute('poster', variant.image || this.current.image);
        } catch (_) { this.disposeModel(); this.status(this.data.strings.modelError); }
      } else this.disposeModel();
      const id = this.form.elements.id;
      id.value = variant ? String(variant.id) : '';
      id.disabled = !variant?.available;
      this.querySelector('[data-add]').disabled = !variant?.available;
      this.querySelector('[data-checkout]').disabled = !variant?.available;
      this.querySelector('[data-add]').textContent = variant?.available ? this.data.strings.add : this.data.strings.unavailable;
      this.querySelector('[data-price]').textContent = variant?.price || this.data.strings.unavailable;
      const image = this.querySelector('[data-selected-image]');
      image.hidden = true;
      this.imageReady = false;
      const imageGeneration = this.imageGeneration = (this.imageGeneration || 0) + 1;
      const source = variant?.image || this.current.image;
      const loading = this.querySelector('[data-image-loading]');
      loading.hidden = Boolean(this.viewerLoaded);
      loading.textContent = this.data.strings.imageLoading;
      const preload = new Image();
      preload.onload = () => { if (imageGeneration !== this.imageGeneration || !this.isConnected) return; image.src = source; this.imageReady = true; image.hidden = Boolean(this.viewerLoaded); loading.hidden = true; };
      preload.onerror = () => { if (imageGeneration !== this.imageGeneration) return; loading.hidden = Boolean(this.viewerLoaded); loading.textContent = this.data.strings.imageError; };
      preload.src = source;
      image.alt = variant?.imageAlt || `${this.current.breed} ${this.data.strings.designRender}`;
      this.querySelector('[data-selection-summary]').textContent = variant ? this.current.options.map(option => `${option.name}: ${variant.selections[option.name]}`).join(' · ') : this.data.strings.unavailable;
      const link = new URL(this.current.url, location.origin); if (variant) link.searchParams.set('variant', variant.id);
      this.querySelector('[data-product-link]').href = link.pathname + link.search;
      this.form.querySelectorAll('[data-option-name]').forEach(select => {
        [...select.options].forEach(item => {
          const candidate = { ...selection, [select.dataset.optionName]: item.value };
          const match = resolveVariant(this.current, candidate);
          item.hidden = !match;
          item.disabled = !match?.available && item.value !== select.value;
        });
      });
      this.querySelector('[data-load-model]').hidden = !variant || !allowedModel(this.manifest, this.current, variant);
      if (updateURL && variant) { const url = new URL(location.href); url.searchParams.set('breed', this.current.handle); url.searchParams.set('variant', variant.id); if (this.modelPreferred && nextModel) url.searchParams.set('mode', this.preferredViewMode === '360' && nextModel.canRotate ? '360' : 'float'); else url.searchParams.delete('mode'); if (url.href !== location.href) history[updateURL === 'push' ? 'pushState' : 'replaceState'](null, '', url); }
    }
    async loadModel() {
      if (!this.current) return;
      const variant = resolveVariant(this.current, this.selection());
      const model = variant && allowedModel(this.manifest, this.current, variant);
      if (!model) return;
      this.modelPreferred = true;
      this.disposeModel();
      const generation = this.modelGeneration;
      this.modelRequested = true;
      this.activeModel = model;
      this.status(this.data.strings.modelLoading);
      this.querySelector('[data-load-model]').disabled = true;
      this.querySelector('[data-close-model]').hidden = false;
      try { await loadViewerRuntime(this.dataset.modelRuntime); } catch (_) { if (generation === this.modelGeneration) { this.disposeModel(); this.status(this.data.strings.modelError); } return; }
      if (generation !== this.modelGeneration || !this.isConnected) return;
      const viewer = document.createElement('model-viewer');
      this.viewer = viewer;
      const requestedModel = this.activeModel;
      const requestedVariant = resolveVariant(this.current, this.selection());
      this.viewMode = 'float';
      viewer.style.visibility = 'hidden';
      viewer.setAttribute('alt', `${this.current.breed} ${this.data.strings.preview}`);
      const help = this.querySelector('[data-rotation-help]');
      if (help?.id) viewer.setAttribute('aria-describedby', help.id);
      viewer.setAttribute('disable-pan', '');
      viewer.setAttribute('disable-zoom', '');
      viewer.setAttribute('interaction-prompt', 'none');
      viewer.setAttribute('camera-orbit', requestedModel.frontView.cameraOrbit);
      viewer.setAttribute('orientation', '0deg 0deg 0deg');
      viewer.setAttribute('min-camera-orbit', 'auto 75deg auto');
      viewer.setAttribute('max-camera-orbit', 'auto 95deg auto');
      viewer.setAttribute('touch-action', 'pan-y');
      viewer.setAttribute('poster', requestedVariant.image || this.current.image);
      viewer.setAttribute('loading', 'eager');
      const fail = () => { if (generation === this.modelGeneration) { this.disposeModel(); this.status(this.data.strings.modelError); } };
      viewer.addEventListener('error', fail, { signal: this.signal });
      viewer.addEventListener('webglcontextlost', fail, { signal: this.signal });
      viewer.addEventListener('load', async () => {
        if (generation !== this.modelGeneration) return;
        clearTimeout(this.modelTimer);
        // Paint the latest approved finish while hidden, including changes made during load.
        while (generation === this.modelGeneration) {
          const preset = this.activeModel.preset;
          try { applyModelFinish(viewer, this.activeModel); } catch (_) { fail(); return; }
          await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
          if (generation !== this.modelGeneration) return;
          if (preset !== this.activeModel.preset) continue;
          this.viewerLoaded = true;
          viewer.style.visibility = 'visible';
          this.querySelector('[data-selected-image]').hidden = true;
          this.querySelector('[data-image-loading]').hidden = true;
          this.setViewMode(this.preferredViewMode === '360' && this.activeModel.canRotate ? '360' : 'float');
          this.setModelMotion(!this.reduced.matches && !document.hidden);
          if (this.focusViewerWhenReady && this.viewMode === '360' && this.modelInViewport && !document.hidden &&
              (document.activeElement === this.querySelector('[data-selected-name]') || document.activeElement === document.body)) this.focusModelControls();
          this.focusViewerWhenReady = false;
          return;
        }
      }, { signal: this.signal });
      this.querySelector('[data-viewer]').append(viewer);
      this.modelTimer = setTimeout(fail, 15000);
      viewer.src = requestedModel.src;
    }
    setViewMode(mode) {
      if (!this.viewerLoaded || (mode !== 'float' && mode !== '360')) return;
      if (mode === '360' && !this.activeModel?.canRotate) return;
      this.viewMode = mode;
      this.preferredViewMode = mode;
      this.setModelMotion(false);
      if (mode === '360') {
        this.viewer.setAttribute('camera-controls', '');
        this.viewer.removeAttribute('tabindex');
        this.viewer.setAttribute('min-camera-orbit', 'auto 0deg auto');
        this.viewer.setAttribute('max-camera-orbit', 'auto 180deg auto');
        this.status(this.data.strings.rotateHelp);
      } else {
        this.viewer.removeAttribute('camera-controls');
        this.viewer.removeAttribute('tabindex');
        this.viewer.setAttribute('min-camera-orbit', 'auto 75deg auto');
        this.viewer.setAttribute('max-camera-orbit', 'auto 95deg auto');
        this.viewer.setAttribute('camera-orbit', this.activeModel.frontView.cameraOrbit);
        this.viewer.jumpCameraToGoal?.();
        this.status(this.data.strings.floatHelp);
      }
      this.updateModelControls();
      this.syncViewURL(mode);
    }
    syncViewURL(mode) {
      const url = new URL(location.href || location.origin);
      if (url.searchParams.get('breed') !== this.current?.handle) return;
      if (mode) url.searchParams.set('mode', mode); else url.searchParams.delete('mode');
      history.replaceState(null, '', url);
    }
    resetFront() {
      if (!this.viewerLoaded) return;
      this.viewer.setAttribute('camera-orbit', this.activeModel.frontView.cameraOrbit);
      this.viewer.jumpCameraToGoal?.();
      if (this.viewMode === '360') this.focusModelControls();
    }
    focusModelControls() {
      const controls = this.viewer?.shadowRoot?.querySelector('[role="img"][tabindex="0"]');
      if (controls) controls.focus({ preventScroll: true });
      else this.viewer?.focus({ preventScroll: true });
    }
    setModelVisibility(visible) {
      this.modelInViewport = Boolean(visible);
      if (!this.modelInViewport) this.setModelMotion(false);
    }
    setModelMotion(play) {
      this.modelMotion = Boolean(play && this.viewerLoaded && this.viewMode === 'float' && this.modelInViewport === true && !this.reduced?.matches && !document.hidden);
      this.querySelector('[data-viewer]')?.classList.toggle('dps__floating', this.modelMotion);
      this.updateModelControls();
    }
    updateModelControls() {
      const shown = Boolean(this.viewerLoaded);
      this.querySelectorAll('[data-view-mode]').forEach(button => { button.hidden = !shown || !this.activeModel?.canRotate; button.setAttribute('aria-pressed', String(button.dataset.viewMode === this.viewMode)); });
      const motion = this.querySelector('[data-model-motion]');
      motion.hidden = !shown || this.viewMode !== 'float' || Boolean(this.reduced?.matches);
      motion.textContent = this.modelMotion ? this.data.strings.pause : this.data.strings.play;
      motion.setAttribute('aria-pressed', String(this.modelMotion));
      this.querySelector('[data-reduced-note]').hidden = !shown || !this.reduced?.matches;
      const reset = this.querySelector('[data-reset-front]');
      if (reset) reset.hidden = !shown || this.viewMode !== '360';
      const help = this.querySelector('[data-rotation-help]');
      if (help) help.hidden = !shown || this.viewMode !== '360';
    }
    closeModel() { this.modelPreferred = false; this.disposeModel(); this.syncViewURL(null); this.querySelector('[data-load-model]')?.focus({ preventScroll: true }); }
    disposeModel() {
      this.stopInitialReveal();
      this.modelGeneration = (this.modelGeneration || 0) + 1;
      this.focusViewerWhenReady = false;
      clearTimeout(this.modelTimer);
      this.viewerLoaded = false;
      this.modelRequested = false;
      this.activeModel = null;
      this.setModelMotion(false);
      if (this.viewer) { this.viewer.removeAttribute('src'); this.viewer.remove(); this.viewer = null; }
      const image = this.querySelector('[data-selected-image]'); if (image) image.hidden = !this.imageReady;
      const close = this.querySelector('[data-close-model]'); if (close) close.hidden = true;
      const open = this.querySelector('[data-load-model]'); if (open) open.disabled = false;
    }
    status(message) { this.querySelector('[data-panel-status]').textContent = message; }
    pauseMotion() { const video = this.querySelector('[data-hero-video]'); const button = this.querySelector('[data-pause]'); if (!video) { if (button) button.hidden = true; return; } video.pause(); if (!button || !this.data) return; button.hidden = false; button.textContent = this.data.strings.play; button.setAttribute('aria-pressed', 'false'); }
    toggleMotion() { const video = this.querySelector('[data-hero-video]'); if (!video) return; if (!video.paused) return this.pauseMotion(); video.play().then(() => { const button = this.querySelector('[data-pause]'); button.textContent = this.data.strings.pause; button.setAttribute('aria-pressed', 'true'); }).catch(() => this.pauseMotion()); }
  }
  customElements.define('dog-pendant-studio', DogPendantStudio);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dog-studio-runtime-qa"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dog-studio-runtime-qa')) customElements.define('dog-studio-runtime-qa', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return; this.ready = true;
    this.strings = JSON.parse(this.querySelector('[data-qa-strings]').textContent);
    this.querySelector('[data-qa-motion]').addEventListener('click', () => this.motion());
    this.querySelector('[data-qa-load]').addEventListener('click', () => this.load());
    this.querySelectorAll('[data-qa-finish]').forEach(button => button.addEventListener('click', () => this.finish(button.dataset.qaFinish)));
  }
  load() {
    this.querySelector('[data-qa-load]').disabled = true;
    this.querySelector('[data-qa-status]').textContent = this.strings.loading;
    const start = performance.now();
    const ready = errors => {
      if (errors || !customElements.get('model-viewer')) return this.fail();
      this.viewer = document.createElement('model-viewer');
      this.viewer.setAttribute('alt', 'Internal Doberman derivative runtime QA');
      this.viewer.setAttribute('camera-orbit', '0deg 90deg auto');
      this.viewer.setAttribute('orientation', '0deg 0deg 0deg');
      this.viewer.setAttribute('interaction-prompt', 'none');
      this.viewer.addEventListener('error', () => this.fail());
      this.viewer.addEventListener('load', () => {
        this.report = {status:'RUNTIME_QA_ONLY',source:new URL(this.dataset.src,location.href).href,load_ms:Math.round(performance.now()-start),material_names:this.viewer.model?.materials?.map(material => material.name),web_derivative_acceptance:false,view360_approval:false};
        this.querySelector('[data-qa-finishes]').hidden = false;
        this.querySelector('[data-qa-motion]').hidden = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.finish('Yellow Gold');
      });
      this.querySelector('[data-qa-stage]').append(this.viewer);
      this.viewer.src = this.dataset.src;
    };
    if (customElements.get('model-viewer')) return ready(false);
    const script=document.createElement('script');script.type='module';script.src=this.dataset.runtime;
    script.addEventListener('load',()=>ready(false),{once:true});script.addEventListener('error',()=>ready(true),{once:true});document.head.append(script);
  }
  finish(name) {
    const presets = {'Yellow Gold':[[.78,.51,.17,1],1,.21],'Rose Gold':[[.76,.39,.28,1],1,.22],'White Gold':[[.78,.80,.82,1],1,.20]};
    const preset=presets[name], pbr=this.viewer?.model?.getMaterialByName('PendantMetal')?.pbrMetallicRoughness;
    if (!pbr || !preset) return this.fail();
    pbr.setBaseColorFactor(preset[0]);pbr.setMetallicFactor(preset[1]);pbr.setRoughnessFactor(preset[2]);
    this.report.finish=name;this.report.baseColorFactor=preset[0];
    this.querySelector('[data-qa-evidence]').textContent=JSON.stringify(this.report,null,2);
    this.querySelector('[data-qa-status]').textContent=name;
  }
  motion() {
    const button=this.querySelector('[data-qa-motion]');const play=button.getAttribute('aria-pressed')!=='true';
    this.viewer?.classList.toggle('dsqa__floating',play);button.setAttribute('aria-pressed',String(play));button.textContent=play?this.strings.pause:this.strings.play;
  }
  fail() { this.querySelector('[data-qa-status]').textContent=this.strings.failed;this.querySelector('[data-qa-load]').disabled=false;this.viewer?.remove(); }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lux-custom-studio-v2"] && !Shopify.designMode) return;
  try {
    
(() => {
  const roots = document.querySelectorAll('[data-lux-atelier]');
  roots.forEach((root) => {
    if (root.dataset.atelierReady === 'true') return;
    root.dataset.atelierReady = 'true';

    const GENERATE_API_URL = 'https://project-bjeym.vercel.app/api/generate';
    const FORMSPREE_ENDPOINT = 'https://formspree.io/f/xpqnyydw';
    const MAX_FILES = 3;
    const MAX_HISTORY = 4;
    const EXPECTED_CONSERVATIVE_HASH = '39ca94dcc6a942f0835c995ea6c3b5114b5b893e328b1ad150aeb7249cd69fe0';
    const EXPECTED_FUNNEL_HASH = 'd8d4204464dd7763ab51d4c16cfa67f67cf04456f0d510aa3a0828026a88d200';
    const EXPECTED_EXCLUSION_VERSION = '2026-08-05.1';
    const EXPECTED_EXCLUSION_COUNT = 7;
    const EXPECTED_EXCLUSION_HASH = '5d357e9211b161e38a93be7b8a31117c7e573f673fbef60bd79e3cd83732c9d4';
    const EXPECTED_RUNTIME_COUNT = 880;
    const EXPECTED_RUNTIME_FUNNEL_COUNTS = { DIRECT_SHOPIFY_CART: 676, START_YOUR_ORDER: 181, PRIVATE_INVOICE: 16, WATCH_QUOTE: 7 };
    const RUNTIME_HANDLE_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
    const stepLabels = ['Concept', 'Materials', 'Details', 'Request'];
    const state = { step: 1, files: [], history: [], activeImage: '', selectedImage: '', submitting: false, generating: false };

    const form = root.querySelector('[data-atelier-form]');
    const panels = [...root.querySelectorAll('[data-atelier-panel]')];
    const tabs = [...root.querySelectorAll('[data-atelier-tab]')];
    const back = root.querySelector('[data-atelier-back]');
    const next = root.querySelector('[data-atelier-next]');
    const status = root.querySelector('[data-atelier-step-status]');
    const prompt = form.elements.concept_prompt;
    const promptCount = root.querySelector('[data-atelier-prompt-count]');
    const generate = root.querySelector('[data-atelier-generate]');
    const variation = root.querySelector('[data-atelier-variation]');
    const useConcept = root.querySelector('[data-atelier-use-concept]');
    const download = root.querySelector('[data-atelier-download]');
    const stageImage = root.querySelector('[data-atelier-active-image]');
    const empty = root.querySelector('[data-atelier-empty]');
    const loading = root.querySelector('[data-atelier-loading]');
    const generationStatus = root.querySelector('[data-atelier-generation-status]');
    const stageTitle = root.querySelector('[data-atelier-stage-title]');
    const stageActions = root.querySelector('[data-atelier-stage-actions]');
    const historyWrap = root.querySelector('[data-atelier-history]');
    const historyGrid = root.querySelector('[data-atelier-history-grid]');
    const message = root.querySelector('[data-atelier-message]');
    const fileInput = root.querySelector('[data-atelier-file-input]');
    const uploadList = root.querySelector('[data-atelier-upload-list]');
    const dropzone = root.querySelector('[data-atelier-dropzone]');
    const submitMessage = root.querySelector('[data-atelier-submit-message]');

    const cleanContextValue = (value) => String(value || '').replace(/\s+/g, ' ').trim();
    const readDiamondCubanContext = () => {
      const params = new URLSearchParams(window.location.search);
      const source = cleanContextValue(params.get('source')).toLowerCase();
      const handle = cleanContextValue(params.get('handle')).toLowerCase();
      const variant = cleanContextValue(params.get('variant'));
      if (!['availability_made_to_order', 'availability_private_quote'].includes(source)) return null;
      if (!/^diamond-cuban-link-chain(?:-|$)/.test(handle)) return null;
      if (!/^\d+$/.test(variant)) return null;
      return { handle, variant };
    };
    const diamondCubanContext = readDiamondCubanContext();
    const diamondCubanPiece = diamondCubanContext
      ? form.querySelector('input[name="piece_type"][value="Cuban Chain"]')
      : null;
    if (diamondCubanPiece) diamondCubanPiece.checked = true;

    const readBelowThresholdContext = () => {
      const params = new URLSearchParams(window.location.search);
      const source = cleanContextValue(params.get('source')).toLowerCase();
      const handle = cleanContextValue(params.get('handle')).toLowerCase();
      const variant = cleanContextValue(params.get('variant'));
      if (source !== 'availability_made_to_order') return null;
      if (!/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(handle)) return null;
      if (/^diamond-cuban-link-chain(?:-|$)/.test(handle)) return null;
      if (!/^\d+$/.test(variant)) return null;
      return { handle, variant };
    };
    const belowThresholdContext = readBelowThresholdContext();

    let contextSafetyPromise;
    const readHandleArray = (values) => Array.isArray(values)
      ? values.map((value) => cleanContextValue(value).toLowerCase()).filter((value) => /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(value))
      : [];
    const readFunnelAssignments = (values) => {
      if (!Array.isArray(values)) return [];
      return values.map((value) => ({
        handle: cleanContextValue(value?.handle).toLowerCase(),
        status: cleanContextValue(value?.status).toUpperCase(),
        onlineStoreSurface: value?.online_store_surface === true,
        funnel: cleanContextValue(value?.funnel).toUpperCase()
      })).filter((value) => value.handle.length > 0);
    };
    const contextSafetySets = () => {
      if (contextSafetyPromise) return contextSafetyPromise;
      contextSafetyPromise = Promise.all([
        fetch(root.dataset.atelierCandidateMapUrl, { credentials: 'same-origin', headers: { Accept: 'application/json' } }),
        fetch(root.dataset.atelierFunnelAssignmentUrl, { credentials: 'same-origin', headers: { Accept: 'application/json' } }),
        fetch(root.dataset.atelierRuntimeExclusionUrl, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      ]).then(async ([candidateResponse, funnelResponse, exclusionResponse]) => {
        if (!candidateResponse.ok || !funnelResponse.ok) throw new Error('Context safety manifest unavailable');
        if (!exclusionResponse.ok) throw new Error('Runtime exclusion ledger unavailable');
        const candidateData = await candidateResponse.json();
        const candidates = readHandleArray(candidateData.candidate_handles);
        const funnelData = await funnelResponse.json();
        const rawAssignments = readFunnelAssignments(funnelData.records);
        const rawHandleSet = new Set(rawAssignments.map((value) => value.handle));
        const rawFunnelCounts = rawAssignments.reduce((counts, value) => {
          counts[value.funnel] = (counts[value.funnel] || 0) + 1;
          return counts;
        }, {});
        const exclusionData = await exclusionResponse.json();
        if (
          candidateData.version !== '2026-08-04.1'
          || candidateData.candidate_hash !== EXPECTED_CONSERVATIVE_HASH
          || candidateData.candidate_count !== 868
          || candidates.length !== 868
          || new Set(candidates).size !== 868
        ) throw new Error('Conservative source safety manifest mismatch');
        if (
          funnelData.version !== '2026-08-03.1'
          || funnelData.manifest_hash !== EXPECTED_FUNNEL_HASH
          || funnelData.record_count !== 887
          || rawAssignments.length !== 887
          || rawHandleSet.size !== 887
          || rawFunnelCounts.DIRECT_SHOPIFY_CART !== 682
          || rawFunnelCounts.START_YOUR_ORDER !== 182
          || rawFunnelCounts.PRIVATE_INVOICE !== 16
          || rawFunnelCounts.WATCH_QUOTE !== 7
        ) throw new Error('Lower-priced funnel manifest mismatch');
        const exclusionRecords = Array.isArray(exclusionData.records) ? exclusionData.records.map((value) => ({
          productGid: cleanContextValue(value?.product_gid),
          manifestHandle: cleanContextValue(value?.manifest_handle).toLowerCase(),
          liveHandle: cleanContextValue(value?.live_handle).toLowerCase(),
          status: cleanContextValue(value?.status).toUpperCase(),
          funnel: cleanContextValue(value?.funnel).toUpperCase(),
          reasonCode: cleanContextValue(value?.reason_code),
          verifiedAt: cleanContextValue(value?.verified_at)
        })) : [];
        const exclusionCanonical = exclusionRecords
          .map((value) => [value.productGid, value.manifestHandle, value.liveHandle, value.status, value.funnel, value.reasonCode, value.verifiedAt].join('|'))
          .join('\n');
        const exclusionDigest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(exclusionCanonical));
        const exclusionHash = Array.from(new Uint8Array(exclusionDigest)).map((byte) => byte.toString(16).padStart(2, '0')).join('');
        const exclusionHandles = new Set(exclusionRecords.map((value) => value.manifestHandle));
        const exclusionGids = new Set(exclusionRecords.map((value) => value.productGid));
        if (
          exclusionData.version !== EXPECTED_EXCLUSION_VERSION
          || exclusionData.record_count !== EXPECTED_EXCLUSION_COUNT
          || exclusionRecords.length !== EXPECTED_EXCLUSION_COUNT
          || exclusionData.exclusion_hash !== EXPECTED_EXCLUSION_HASH
          || exclusionHash !== EXPECTED_EXCLUSION_HASH
          || exclusionHandles.size !== EXPECTED_EXCLUSION_COUNT
          || exclusionGids.size !== EXPECTED_EXCLUSION_COUNT
          || exclusionRecords.some((value) => !rawHandleSet.has(value.manifestHandle))
          || exclusionRecords.some((value) => candidates.includes(value.manifestHandle))
        ) throw new Error('Runtime exclusion ledger mismatch');
        const assignments = rawAssignments.filter((value) => !exclusionHandles.has(value.handle));
        if (assignments.some((value) => !RUNTIME_HANDLE_PATTERN.test(value.handle))) throw new Error('Runtime funnel manifest contains an unreviewed invalid handle');
        const assignmentHandles = new Set(assignments.map((value) => value.handle));
        const funnelCounts = assignments.reduce((counts, value) => {
          counts[value.funnel] = (counts[value.funnel] || 0) + 1;
          return counts;
        }, {});
        if (
          assignments.length !== EXPECTED_RUNTIME_COUNT
          || assignmentHandles.size !== EXPECTED_RUNTIME_COUNT
          || funnelCounts.DIRECT_SHOPIFY_CART !== EXPECTED_RUNTIME_FUNNEL_COUNTS.DIRECT_SHOPIFY_CART
          || funnelCounts.START_YOUR_ORDER !== EXPECTED_RUNTIME_FUNNEL_COUNTS.START_YOUR_ORDER
          || funnelCounts.PRIVATE_INVOICE !== EXPECTED_RUNTIME_FUNNEL_COUNTS.PRIVATE_INVOICE
          || funnelCounts.WATCH_QUOTE !== EXPECTED_RUNTIME_FUNNEL_COUNTS.WATCH_QUOTE
        ) throw new Error('Runtime funnel lookup mismatch');
        return {
          blocked: new Set(candidates),
          assignments: new Map(assignments.map((value) => [value.handle, value]))
        };
      });
      return contextSafetyPromise;
    };
    const verifiedBelowThresholdVariants = async (product, handle) => {
      const safetySets = await contextSafetySets();
      if (safetySets.blocked.has(handle)) throw new Error('Product context is blocked by the compliance manifest');
      const assignment = safetySets.assignments.get(handle);
      if (!assignment) throw new Error('Product context is absent from the lower-priced funnel manifest');
      if (assignment.funnel !== 'START_YOUR_ORDER') throw new Error('Product context is not assigned to Custom Studio');
      if (!assignment.onlineStoreSurface) throw new Error('Product context has no verified Online Store surface');
      if (assignment.status !== 'ACTIVE' && assignment.status !== 'UNLISTED') throw new Error('Product context is not in a verified public status');
      const variants = Array.isArray(product.variants) ? product.variants : [];
      if (!variants.length) throw new Error('Product variants unavailable');
      const priceSourcesAreValid = variants.every((item) => {
        const currentPrice = Number(item.price);
        const compareAtPrice = item.compare_at_price == null || item.compare_at_price === '' ? 0 : Number(item.compare_at_price);
        return Number.isFinite(currentPrice) && Number.isFinite(compareAtPrice);
      });
      if (!priceSourcesAreValid) throw new Error('Product context has no valid price data');
      return variants;
    };

    const showMessage = (text, isError = false) => {
      message.hidden = false;
      message.textContent = text;
      message.style.borderColor = isError ? 'rgba(255,120,110,.5)' : 'rgba(214,181,107,.3)';
      message.style.color = isError ? '#ffb2ac' : '#f3dfaa';
    };

    const getValue = (name) => {
      const field = form.elements[name];
      if (!field) return '';
      if (field instanceof RadioNodeList) return field.value || '';
      return String(field.value || '').trim();
    };

    const selectedPiece = () => form.querySelector('input[name="piece_type"]:checked')?.value || 'Custom jewelry';

    const buildPrompt = () => {
      const pieces = [
        getValue('concept_prompt'),
        `Jewelry type: ${selectedPiece()}.`,
        `Presentation: ${getValue('concept_style')}.`,
        `Primary camera view: ${getValue('concept_view')}.`,
        getValue('metal_purity') ? `Metal: ${getValue('metal_purity')} ${getValue('metal_color')}.` : '',
        getValue('stone_type') ? `Stone direction: ${getValue('stone_type')}; shape: ${getValue('stone_shape') || 'designer selected'}; setting: ${getValue('setting_style') || 'designer selected'}; coverage: ${getValue('stone_coverage') || 'designer selected'}.` : '',
        getValue('dimensions') ? `Approximate dimensions: ${getValue('dimensions')}.` : '',
        getValue('carat_target') ? `Carat target: ${getValue('carat_target')}.` : '',
        getValue('lettering') ? `Lettering: ${getValue('lettering')}.` : '',
        getValue('engraving') ? `Engraving: ${getValue('engraving')}.` : '',
        getValue('special_instructions') ? `Special instructions: ${getValue('special_instructions')}.` : '',
        'Create one original 1Luxury Miami jewelry concept. Show only the jewelry requested. Use realistic precious-metal reflections, believable stone settings, manufacturable proportions, high-end studio lighting, and no unrelated logos or text.'
      ].filter(Boolean);
      return pieces.join(' ');
    };

    const collectSelections = () => ({
      piece_type: selectedPiece(),
      concept_style: getValue('concept_style'),
      concept_view: getValue('concept_view'),
      metal_purity: getValue('metal_purity'),
      metal_color: getValue('metal_color'),
      stone_type: getValue('stone_type'),
      stone_shape: getValue('stone_shape'),
      setting_style: getValue('setting_style'),
      stone_coverage: getValue('stone_coverage'),
      dimensions: getValue('dimensions'),
      carat_target: getValue('carat_target'),
      budget_range: getValue('budget_range'),
      timeline: getValue('timeline'),
      lettering: getValue('lettering'),
      engraving: getValue('engraving'),
      special_instructions: getValue('special_instructions')
    });

    const compressImage = (file, max = 1400, quality = .82) => new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onerror = reject;
      reader.onload = (event) => {
        const image = new Image();
        image.onerror = reject;
        image.onload = () => {
          let width = image.width;
          let height = image.height;
          if (width > max || height > max) {
            const ratio = Math.min(max / width, max / height);
            width = Math.round(width * ratio);
            height = Math.round(height * ratio);
          }
          const canvas = document.createElement('canvas');
          canvas.width = width;
          canvas.height = height;
          canvas.getContext('2d').drawImage(image, 0, 0, width, height);
          resolve(canvas.toDataURL('image/jpeg', quality));
        };
        image.src = event.target.result;
      };
      reader.readAsDataURL(file);
    });

    const renderFiles = () => {
      uploadList.innerHTML = '';
      state.files.forEach((entry, index) => {
        const card = document.createElement('div');
        card.className = 'lux-atelier__upload-item';
        const img = document.createElement('img');
        img.src = entry.dataUrl;
        img.alt = `Reference image ${index + 1}: ${entry.name}`;
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.textContent = '×';
        remove.setAttribute('aria-label', `Remove ${entry.name}`);
        remove.addEventListener('click', () => { state.files.splice(index, 1); renderFiles(); });
        card.append(img, remove);
        uploadList.append(card);
      });
    };

    const addFiles = async (files) => {
      const candidates = [...files].slice(0, Math.max(0, MAX_FILES - state.files.length));
      for (const file of candidates) {
        if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) continue;
        if (file.size > 12 * 1024 * 1024) { showMessage(`${file.name} is larger than 12 MB.`, true); continue; }
        try { state.files.push({ name: file.name, dataUrl: await compressImage(file) }); } catch (error) { showMessage(`Could not prepare ${file.name}.`, true); }
      }
      renderFiles();
      fileInput.value = '';
    };

    const setActiveImage = (url, select = false) => {
      state.activeImage = url;
      if (select) state.selectedImage = url;
      stageImage.src = url;
      stageImage.hidden = false;
      empty.hidden = true;
      loading.hidden = true;
      stageActions.hidden = false;
      generationStatus.textContent = select ? 'Selected' : 'Rendered';
      stageTitle.textContent = select ? 'Selected concept' : 'Concept variation';
      renderHistory();
      syncSelectedPreview();
    };

    const renderHistory = () => {
      historyGrid.innerHTML = '';
      historyWrap.hidden = state.history.length === 0;
      state.history.forEach((url, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = `lux-atelier__history-item${url === state.activeImage ? ' is-active' : ''}`;
        button.setAttribute('aria-label', `View concept variation ${index + 1}`);
        const img = document.createElement('img');
        img.src = url;
        img.alt = `Concept variation ${index + 1}`;
        button.append(img);
        button.addEventListener('click', () => setActiveImage(url, url === state.selectedImage));
        historyGrid.append(button);
      });
    };

    const runGeneration = async (isVariation = false) => {
      const basePrompt = getValue('concept_prompt');
      if (basePrompt.length < 20) {
        prompt.setAttribute('aria-invalid', 'true');
        prompt.focus();
        showMessage('Please describe the jewelry idea in at least 20 characters.', true);
        return;
      }
      prompt.removeAttribute('aria-invalid');
      if (state.generating) return;
      state.generating = true;
      generate.disabled = true;
      variation.disabled = true;
      empty.hidden = true;
      stageImage.hidden = true;
      loading.hidden = false;
      stageActions.hidden = true;
      generationStatus.textContent = 'Rendering';
      stageTitle.textContent = isVariation ? 'Creating another variation' : 'Creating your concept';
      message.hidden = true;

      try {
        const payload = {
          prompt: buildPrompt() + (isVariation ? ' Produce a meaningfully different variation while preserving the requested jewelry specifications.' : ''),
          selections: collectSelections(),
          referenceImages: state.files.map((item) => item.dataUrl),
          referenceFileNames: state.files.map((item) => item.name),
          generationMode: isVariation ? 'variation' : 'guided_custom_studio'
        };
        const response = await fetch(GENERATE_API_URL, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
        const data = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(data.error || 'The concept could not be generated.');
        if (!data.imageUrl) throw new Error('No concept image was returned.');
        state.history = [data.imageUrl, ...state.history.filter((url) => url !== data.imageUrl)].slice(0, MAX_HISTORY);
        setActiveImage(data.imageUrl, state.selectedImage === '');
        showMessage('Concept created. Select it, generate a variation, or continue to materials.');
      } catch (error) {
        loading.hidden = true;
        empty.hidden = state.history.length > 0;
        if (state.history.length) setActiveImage(state.history[0], state.history[0] === state.selectedImage);
        generationStatus.textContent = 'Try again';
        stageTitle.textContent = 'Generation was not completed';
        showMessage(error.message || 'The concept could not be generated. Please try again.', true);
      } finally {
        state.generating = false;
        generate.disabled = false;
        variation.disabled = false;
      }
    };

    const syncSelectedPreview = () => {
      const selected = state.selectedImage || state.activeImage;
      root.querySelectorAll('[data-atelier-summary-image],[data-atelier-review-image]').forEach((img) => {
        if (selected) { img.src = selected; img.hidden = false; } else { img.hidden = true; }
      });
      root.querySelectorAll('[data-atelier-summary-empty],[data-atelier-review-empty]').forEach((emptyEl) => { emptyEl.hidden = Boolean(selected); });
      root.querySelector('[data-atelier-summary-title]').textContent = selectedPiece();
      root.querySelector('[data-atelier-summary-copy]').textContent = getValue('concept_prompt') || 'Continue with written specifications only.';
    };

    const updateChecklist = () => {
      const values = {
        concept: Boolean(state.selectedImage || getValue('concept_prompt').length >= 20),
        materials: Boolean(getValue('metal_purity') || getValue('stone_type')),
        budget: Boolean(getValue('budget_range')),
        contact: Boolean(getValue('full_name') && getValue('email') && getValue('phone'))
      };
      Object.entries(values).forEach(([key, complete]) => root.querySelector(`[data-check="${key}"]`)?.classList.toggle('is-complete', complete));
    };

    const renderSummary = () => {
      const metal = [getValue('metal_purity'), getValue('metal_color')].filter(Boolean).join(' · ') || 'To be reviewed';
      const stones = [getValue('stone_type'), getValue('stone_shape')].filter(Boolean).join(' · ') || 'To be reviewed';
      root.querySelector('[data-summary="piece"]').textContent = selectedPiece();
      root.querySelector('[data-summary="metal"]').textContent = metal;
      root.querySelector('[data-summary="stones"]').textContent = stones;
      root.querySelector('[data-summary="budget"]').textContent = getValue('budget_range') || 'Not selected';
      root.querySelector('[data-summary="timeline"]').textContent = getValue('timeline') || 'Flexible';
      syncSelectedPreview();
      updateChecklist();
    };

    const applyDiamondCubanPrefill = async () => {
      if (!diamondCubanContext || !diamondCubanPiece) return;
      const initialPrompt = prompt.value;
      const response = await fetch(`/products/${encodeURIComponent(diamondCubanContext.handle)}.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) throw new Error('Product context unavailable');
      const product = await response.json();
      if (cleanContextValue(product.handle).toLowerCase() !== diamondCubanContext.handle) throw new Error('Product context mismatch');
      if (prompt.value !== initialPrompt) return;

      const variants = await verifiedBelowThresholdVariants(product, diamondCubanContext.handle);
      const variant = variants.find((item) => String(item.id) === diamondCubanContext.variant);
      if (!variant) throw new Error('Selected configuration unavailable');
      const defaultOnly = variants.length === 1 && cleanContextValue(variant.title) === 'Default Title';

      const title = cleanContextValue(product.title);
      if (!title) throw new Error('Product title unavailable');
      const productUrl = `${window.location.origin}/products/${encodeURIComponent(diamondCubanContext.handle)}`;
      const lines = [`I’m interested in ${title}.`, `Product: ${productUrl}`];

      if (defaultOnly) {
        lines.push('Final metal, diamond, length, weight, carat weight and pricing specifications to be confirmed privately.');
      } else {
        const optionNames = Array.isArray(product.options)
          ? product.options.map((option) => cleanContextValue(typeof option === 'string' ? option : option?.name))
          : [];
        const optionValues = Array.isArray(variant.options) ? variant.options.map((value) => cleanContextValue(value)) : [];
        const normalizeOptionName = (name) => {
          if (/color/i.test(name)) return 'Gold color';
          if (/diamond|stone/i.test(name)) return 'Diamond origin';
          if (/size|length/i.test(name)) return 'Length';
          return name;
        };
        const details = optionValues
          .map((value, index) => ({ name: normalizeOptionName(optionNames[index] || ''), value }))
          .filter((item) => item.value && item.value !== 'Default Title');
        const widths = [...title.matchAll(/\b\d+(?:\.\d+)?mm\b/gi)]
          .map((match) => cleanContextValue(match[0]))
          .filter((value, index, values) => values.findIndex((item) => item.toLowerCase() === value.toLowerCase()) === index);
        if (widths.length && !details.some((item) => item.name === 'Width')) {
          details.push({ name: 'Width', value: widths.join(' to ') });
        }
        const variantTitle = cleanContextValue(variant.title);
        if (variantTitle && variantTitle !== 'Default Title') lines.push(`Selected variant: ${variantTitle}.`);
        if (details.length) {
          lines.push(`Selected configuration: ${details.map((item) => `${item.name ? `${item.name}: ` : ''}${item.value}`).join(' / ')}.`);
        }
      }
      lines.push('Please confirm the final specifications, production details, insured delivery and private pricing.');
      prompt.value = lines.join('\n');
      prompt.dispatchEvent(new Event('input', { bubbles: true }));
      renderSummary();
    };

    const applyBelowThresholdPrefill = async () => {
      if (!belowThresholdContext) return;
      const initialPrompt = prompt.value;
      const response = await fetch(`/products/${encodeURIComponent(belowThresholdContext.handle)}.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) throw new Error('Product context unavailable');
      const product = await response.json();
      if (cleanContextValue(product.handle).toLowerCase() !== belowThresholdContext.handle) throw new Error('Product context mismatch');
      if (prompt.value !== initialPrompt) return;

      const variants = await verifiedBelowThresholdVariants(product, belowThresholdContext.handle);

      const variant = variants.find((item) => String(item.id) === belowThresholdContext.variant);
      if (!variant) throw new Error('Selected configuration unavailable');
      const title = cleanContextValue(product.title);
      if (!title) throw new Error('Product title unavailable');

      const classification = `${cleanContextValue(product.type)} ${title}`.toLowerCase();
      const pieceValue = /cuban/.test(classification)
        ? 'Cuban Chain'
        : /pendant/.test(classification)
          ? 'Pendant'
          : /bracelet/.test(classification)
            ? 'Bracelet'
            : /earring/.test(classification)
              ? 'Earrings'
              : /necklace/.test(classification)
                ? 'Necklace'
                : /ring/.test(classification)
                  ? 'Ring'
                  : '';
      const pieceInput = pieceValue ? form.querySelector(`input[name="piece_type"][value="${pieceValue}"]`) : null;
      if (pieceInput) pieceInput.checked = true;

      const lines = [
        `I’d like to use ${title} as the starting reference for a private made-to-order review.`,
        `Reference page: ${window.location.origin}/products/${encodeURIComponent(belowThresholdContext.handle)}`
      ];
      const optionNames = Array.isArray(product.options)
        ? product.options.map((option) => cleanContextValue(typeof option === 'string' ? option : option?.name))
        : [];
      const optionValues = Array.isArray(variant.options) ? variant.options.map((value) => cleanContextValue(value)) : [];
      const details = optionValues
        .map((value, index) => ({ name: optionNames[index] || '', value }))
        .filter((item) => item.value && item.value !== 'Default Title');
      const variantTitle = cleanContextValue(variant.title);
      if (variantTitle && variantTitle !== 'Default Title') lines.push(`Selected variant: ${variantTitle}.`);
      if (details.length) {
        lines.push(`Selected configuration: ${details.map((item) => `${item.name ? `${item.name}: ` : ''}${item.value}`).join(' / ')}.`);
      }
      lines.push('Please review the requested design direction, final specifications, timing and delivery details.');
      prompt.value = lines.join('\n');
      prompt.dispatchEvent(new Event('input', { bubbles: true }));
      renderSummary();
      showMessage('The verified product context was added as a starting reference.');
    };

    const validateStep = () => {
      const panel = panels[state.step - 1];
      const fields = [...panel.querySelectorAll('input,select,textarea')].filter((field) => !field.disabled && field.willValidate);
      fields.forEach((field) => field.removeAttribute('aria-invalid'));
      const invalid = fields.find((field) => !field.checkValidity());
      if (invalid) {
        invalid.setAttribute('aria-invalid', 'true');
        invalid.reportValidity();
        invalid.focus();
        return false;
      }
      return true;
    };

    const showStep = (step) => {
      state.step = Math.max(1, Math.min(4, step));
      panels.forEach((panel, index) => { panel.hidden = index !== state.step - 1; });
      tabs.forEach((tab, index) => {
        const active = index === state.step - 1;
        tab.classList.toggle('is-active', active);
        active ? tab.setAttribute('aria-current', 'step') : tab.removeAttribute('aria-current');
      });
      back.disabled = state.step === 1;
      next.hidden = state.step === 4;
      status.textContent = `Step ${state.step} of 4 · ${stepLabels[state.step - 1]}`;
      renderSummary();
      root.querySelector('[data-atelier-workspace]').scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    };

    const submitRequest = async () => {
      if (state.submitting) return;
      if (!form.checkValidity()) { form.reportValidity(); return; }
      state.submitting = true;
      const submit = root.querySelector('[data-atelier-submit]');
      submit.disabled = true;
      submit.textContent = 'Sending…';
      submitMessage.hidden = false;
      submitMessage.textContent = 'Sending your request securely…';

      const selections = collectSelections();
      const payload = {
        source: '1Luxury Custom Studio V2',
        full_name: getValue('full_name'),
        email: getValue('email'),
        phone: getValue('phone'),
        preferred_contact: getValue('preferred_contact'),
        service_format: getValue('service_format'),
        instagram: getValue('instagram'),
        piece_type: selectedPiece(),
        design_description: getValue('concept_prompt'),
        generated_concept_selected: state.selectedImage || state.activeImage,
        generated_concept_variations: state.history.join('\n'),
        reference_file_names: state.files.map((item) => item.name).join(', '),
        selections_json: JSON.stringify(selections, null, 2),
        budget_range: getValue('budget_range'),
        desired_timeline: getValue('timeline'),
        deposit_intent: form.elements.deposit_intent.checked ? 'Yes' : 'No',
        contact_consent: form.elements.contact_consent.checked ? 'Yes' : 'No'
      };

      try {
        const response = await fetch(FORMSPREE_ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) });
        const data = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(data?.errors?.[0]?.message || 'The request could not be sent.');
        submitMessage.textContent = 'Thank you. Your design request was sent to 1Luxury Miami for private review.';
        submitMessage.style.color = '#baf0c3';
        submitMessage.style.borderColor = 'rgba(80,190,110,.45)';
      } catch (error) {
        submitMessage.textContent = error.message || 'The request could not be sent. Please try again.';
        submitMessage.style.color = '#ffb2ac';
        submitMessage.style.borderColor = 'rgba(255,120,110,.5)';
      } finally {
        state.submitting = false;
        submit.disabled = false;
        submit.textContent = 'Send My Design Request';
      }
    };

    prompt.addEventListener('input', () => { promptCount.textContent = prompt.value.length; updateChecklist(); });
    root.querySelectorAll('[data-atelier-prompt-example]').forEach((button) => button.addEventListener('click', () => { prompt.value = button.dataset.atelierPromptExample; prompt.dispatchEvent(new Event('input', { bubbles: true })); prompt.focus(); }));
    fileInput.addEventListener('change', () => addFiles(fileInput.files));
    ['dragenter','dragover'].forEach((eventName) => dropzone.addEventListener(eventName, (event) => { event.preventDefault(); dropzone.style.background = 'rgba(214,181,107,.11)'; }));
    ['dragleave','drop'].forEach((eventName) => dropzone.addEventListener(eventName, (event) => { event.preventDefault(); dropzone.style.background = ''; if (eventName === 'drop' && event.dataTransfer?.files) addFiles(event.dataTransfer.files); }));
    generate.addEventListener('click', () => runGeneration(false));
    variation.addEventListener('click', () => runGeneration(true));
    useConcept.addEventListener('click', () => { if (!state.activeImage) return; state.selectedImage = state.activeImage; setActiveImage(state.activeImage, true); showMessage('This concept is selected for your private design request.'); });
    download.addEventListener('click', () => { if (!state.activeImage) return; const link = document.createElement('a'); link.href = state.activeImage; link.download = '1luxury-custom-concept.jpg'; document.body.append(link); link.click(); link.remove(); });
    root.querySelector('[data-atelier-clear-history]').addEventListener('click', () => { state.history = []; state.activeImage = ''; state.selectedImage = ''; stageImage.hidden = true; stageActions.hidden = true; historyWrap.hidden = true; empty.hidden = false; generationStatus.textContent = 'Ready'; stageTitle.textContent = 'Your preview will appear here'; syncSelectedPreview(); });
    root.querySelector('[data-atelier-start]').addEventListener('click', () => root.querySelector('[data-atelier-workspace]').scrollIntoView({ behavior: 'smooth', block: 'start' }));
    tabs.forEach((tab) => tab.addEventListener('click', () => { const step = Number(tab.dataset.atelierTab); if (step <= state.step || validateStep()) showStep(step); }));
    back.addEventListener('click', () => showStep(state.step - 1));
    next.addEventListener('click', () => { if (validateStep()) showStep(state.step + 1); });
    form.addEventListener('input', updateChecklist);
    form.addEventListener('change', () => { renderSummary(); updateChecklist(); });
    form.addEventListener('submit', (event) => { event.preventDefault(); submitRequest(); });

    promptCount.textContent = prompt.value.length;
    showStep(1);
    applyDiamondCubanPrefill().catch(() => {
      if (diamondCubanContext) showMessage('We could not load the selected product configuration. Please return to the product page and try the request again.', true);
    });
    applyBelowThresholdPrefill().catch(() => {
      if (belowThresholdContext) showMessage('We could not validate this item for the made-to-order handoff. Please return to the product page and try again.', true);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["one-luxury-oval-specials-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-one-luxury-oval-specials-home]';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const mountVideo = (section) => {
      if (!section || section.dataset.ovalVideoMounted === 'true') return;

      const video = section.querySelector('video');
      if (!video) return;

      section.dataset.ovalVideoMounted = 'true';
      let visible = false;

      const syncPlayback = () => {
        if (reducedMotion.matches || !visible || document.hidden) {
          video.pause();
          return;
        }

        const playback = video.play();
        if (playback && typeof playback.catch === 'function') playback.catch(() => {});
      };

      const observer = new IntersectionObserver(
        (entries) => {
          visible = entries.some((entry) => entry.isIntersecting && entry.intersectionRatio > 0.2);
          syncPlayback();
        },
        { threshold: [0, 0.2, 0.5] }
      );

      observer.observe(section);
      reducedMotion.addEventListener('change', syncPlayback);
      document.addEventListener('visibilitychange', syncPlayback);
    };

    const mountWithin = (root) => {
      if (root.matches && root.matches(selector)) mountVideo(root);
      root.querySelectorAll(selector).forEach(mountVideo);
    };

    mountWithin(document);
    document.addEventListener('shopify:section:load', (event) => mountWithin(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["one-luxury-watch-quote-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const cleanText = (value, maximumLength = 120) => String(value || '')
      .replace(/[\u0000-\u001f\u007f]/g, ' ')
      .trim()
      .slice(0, maximumLength);

    const cleanSlug = (value, maximumLength = 128) => {
      const normalized = String(value || '').trim().toLowerCase();
      return new RegExp(`^[a-z0-9_-]{1,${maximumLength}}$`).test(normalized) ? normalized : '';
    };

    const cleanNumericId = (value) => /^\d{1,24}$/.test(String(value || '')) ? String(value) : '';

    const sameOriginPath = (value, requiredPrefix = '/') => {
      if (!value) return '';
      try {
        const parsed = new URL(value, window.location.origin);
        if (parsed.origin !== window.location.origin || !parsed.pathname.startsWith(requiredPrefix)) return '';
        return parsed.pathname;
      } catch (_) {
        return '';
      }
    };

    const productUrl = (value) => {
      const path = sameOriginPath(value, '/products/');
      return path ? `${window.location.origin}${path}` : '';
    };

    const initializeForm = (form) => {
      if (!form || form.dataset.watchQuoteInitialized === 'true') return;
      form.dataset.watchQuoteInitialized = 'true';

      const params = new URLSearchParams(window.location.search);
      const setValue = (selector, value) => {
        const field = form.querySelector(selector);
        if (field) field.value = value;
      };

      const handle = cleanSlug(params.get('handle'));
      const variant = cleanNumericId(params.get('variant'));
      // URL values are customer-supplied context, never price approval.
      const source = cleanSlug(params.get('source'), 64) || 'watch_quote';
      const inquiryType = cleanText(params.get('inquiry_type'), 40) === 'Watch trade-in' ? 'Watch trade-in' : '';
      const safeProductUrl = productUrl(params.get('product_url'));
      const safeSourcePage = sameOriginPath(params.get('source_page')) || sameOriginPath(document.referrer);

      setValue('[data-watch-quote-product]', cleanText(params.get('product')));
      setValue('[data-watch-quote-variant]', variant);
      setValue('[data-watch-quote-price]', 'Price on Request');
      setValue('[data-watch-quote-brand]', cleanText(params.get('brand'), 80));
      setValue('[data-watch-quote-model]', cleanText(params.get('model'), 80));
      setValue('[data-watch-quote-reference]', cleanText(params.get('reference'), 80));
      setValue('[data-watch-quote-source-collection]', cleanSlug(params.get('collection')));
      setValue('[data-watch-quote-page-source]', source);
      setValue('[data-watch-quote-source-page]', safeSourcePage);
      setValue('[data-watch-quote-current-url]', window.location.pathname);
      setValue('[data-watch-quote-inquiry-type]', inquiryType);
      if (inquiryType === 'Watch trade-in') setValue('[data-watch-quote-trade-in]', 'Yes');

      if (handle) {
        setValue('[data-watch-quote-product-handle]', handle);
        setValue('[data-watch-quote-product-url]', safeProductUrl || `${window.location.origin}/products/${handle}`);
      } else {
        setValue('[data-watch-quote-product-url]', safeProductUrl);
      }

      if (handle) {
        const endpoint = new URL(`/products/${encodeURIComponent(handle)}`, window.location.origin);
        endpoint.searchParams.set('view', 'watch-quote-context');
        if (variant) endpoint.searchParams.set('variant', variant);
        if (/^\d+$/.test(params.get('preview_theme_id') || '')) endpoint.searchParams.set('preview_theme_id', params.get('preview_theme_id'));
        fetch(endpoint, { credentials: 'same-origin', headers: { Accept: 'text/html' } })
          .then(response => { if (!response.ok) throw new Error('Context unavailable'); return response.json(); })
          .then(context => {
            if (context.handle !== handle || (variant && String(context.variant_id) !== variant)) throw new Error('Variant mismatch');
            setValue('[data-watch-quote-product]', context.title);
            setValue('[data-watch-quote-variant]', String(context.variant_id));
            const verifiedProductUrl = new URL(`/products/${encodeURIComponent(context.handle)}`, window.location.origin);
            verifiedProductUrl.searchParams.set('variant', String(context.variant_id));
            setValue('[data-watch-quote-product-url]', verifiedProductUrl.href);
            const verifiedAmount = context.price_mode === 'public_price' && Number.isSafeInteger(context.price_cents) && context.price_cents > 0 && /^[A-Z]{3}$/.test(context.currency);
            setValue('[data-watch-quote-price]', verifiedAmount
              ? `${context.currency} ${(context.price_cents / 100).toFixed(2)} (subject to review)`
              : 'Price on Request');
            form.dataset.watchQuoteContext = 'verified';
            if (context.unavailable) {
              form.querySelector('button[type="submit"]').disabled = true;
              form.querySelector('[data-watch-quote-context-status]').textContent = 'This watch is currently unavailable.';
            }
          })
          .catch(() => {
            // Keep the inquiry usable, without importing an unverified numeric price.
            form.dataset.watchQuoteContext = 'unavailable';
            setValue('[data-watch-quote-price]', 'Price on Request');
            form.querySelector('[data-watch-quote-context-status]').textContent = 'Watch details will be confirmed during private review.';
          });
      }

    };

    const initializeWithin = (scope) => {
      if (scope.matches?.('[data-watch-quote-form]')) initializeForm(scope);
      scope.querySelectorAll?.('[data-watch-quote-form]').forEach(initializeForm);
    };

    initializeWithin(document);
    if (!window.OneLuxuryWatchQuoteSectionLoadBound) {
      window.OneLuxuryWatchQuoteSectionLoadBound = true;
      document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
